import { DefaultRuntime } from "@pnp/common";
export function setup(config) {
    DefaultRuntime.assign(config);
}
//# sourceMappingURL=pnplibconfig.js.map